export const FORM_DESTROY = 'FORM_DESTROY';
export const FORM_START_SUBMIT = 'FORM_START_SUBMIT';
export const FORM_STOP_SUBMIT = 'FORM_STOP_SUBMIT';
export const FORM_SET_SUBMIT_FAILED = 'FORM_SET_SUBMIT_FAILED';
export const FORM_SET_SUBMIT_SUCCEEDED = 'FORM_SET_SUBMIT_SUCCEEDED';
